/**
 * 行程接口相关数据
 */

import {combineReducers} from 'redux';
import allTrips from './allTrips';
import demo from './demo';
import detail from './detail';
import params from './params';
import editing from './editing';
import selectedDay from './selectedDay';
import paramsCities from './paramsCities';

export default combineReducers({
  allTrips,
  // Demo行程
  demo,
  // 行程详情
  detail,
  // 创建新行程的参数
  params,
  paramsCities,

  editing,

  selectedDay
});




// WEBPACK FOOTER //
// ./src/store/reducers/trip/index.js